function positionToStringId(position) {
    return `${position.column}:${position.row}`;
}
export default positionToStringId;
